module.exports = __webpack_public_path__ + "static/SSAFE-67e58db04531c067d2af46510e3bfc48.pdf";